module.exports = __webpack_public_path__ + "c0e65828a43ad0d133d272086cb9da13.svg";